@if (title) {
  <p role="heading" aria-level="2" class="mb-xs text-base">{{ title }}</p>
}
<div class="flex flex-col flex-wrap justify-center gap-md sm:flex-row md:justify-start">
  <ng-content select="bgo-hero-call-to-action,cft-call-to-action"></ng-content>
</div>
